






























































































































import DragListTopic from "./components/DragListTopic.vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import { TopicsService } from "@/services/Topics.service.ts";
import InputNumber from "@/views/components/input/InputNumber.vue";
import InputString from "@/views/components/input/InputString.vue";
import { Topics } from "@/models/Topic.ts";

@Component({
  name: "RecommendCar",
  components: {
    DragListTopic,
    InputNumber,
    InputString
  }
})
export default class TopicsWork extends Vue {
  @Prop({ default: "" })
  title: string;
  public topicService = new TopicsService();
  public topicData: Topics;
  public topicList: Topics[] = [];
  // public kyotenDataList: KyotenData[] = [];
  public options: any = {
    group: "reccar"
  };
  // public form: any = {
  //   kyotenSelected: ""
  // };

  constructor() {
    super();
    this.topicData = {
      id: 0,
      topicsBody: "",
      defDispKbn: 1,
      enabled: 1
    };
  }

  get topicId() {
    if (this.topicList.length == 0) {
      return 0;
    }
    const id = this.topicList[this.topicList.length - 1].id;
    return id ? id + 1 : 0;
  }

  public onSubmit() {
    const data = {
      id: this.topicId,
      ...this.topicData
    };
    this.addTopicList({ ...data });
  }

  public onEdit(event: any) {
    console.log("​onEdit", event);
    if (event) {
      const { id, topicsBody, defDispKbn, enabled } = event;
      this.addTopicList({
        id,
        topicsBody,
        defDispKbn,
        enabled
      });
    }
  }

  onChangeEnabled(param: any) {
    const editPromise = this.topicService.editTopic(param.enabledItem);
    let deletePromise = this.topicService.deleteTopic(param.idDelete);
    Promise.all([editPromise, deletePromise]).then((res: any) => {
      if (!res.every((e: any) => e == 200)) {
        this.$message.error("エラー");
      }
      this.getTopicList();
    });
  }

  // public async onDelete(event: any) {
  //   console.log("​onDelete -> id", event);
  //   const result = await this.topicService.deleteTopic(event);
  //   if (result) {
  //     console.log("​onDelete ->", result);
  //     this.getTopicList();
  //   }
  // }

  // =====================================

  // public async getKyotenDataList() {
  //   const response = await this.topicService.getKyotens();
  //   if (response) {
  //     this.$set(this, "kyotenDataList", response);
  //   }
  // }

  public async getTopicList() {
    const result = await this.topicService.getTopics();
    if (result) {
      const data = result.map((e: any) => {
        return { ...e, isEdit: false };
      });
      this.$set(this, "topicList", data);
    } else {
      this.$set(this, "topicList", []);
    }
  }

  public async addTopicList(data: any) {
    console.log("add", data);
    const result = await this.topicService.editTopic(data);
    if (result) {
      console.log("​addTopicList", JSON.parse(JSON.stringify(result)));
      this.getTopicList();
    }
  }

  private created() {
    // this.getKyotenDataList();
    // this.form.kyotenSelected = localStorage.getItem("kyotenCd");
    this.getTopicList();
  }
}
